enum KubernetesAppName {
  Dealership = 'dealership',
  Homepage = 'homepage',
  MerchUI = 'merchui',
  SRP = 'srp',
  VDP = 'vdp'
}

export default KubernetesAppName;
